import { onMounted } from 'vue';

export default () => {
  function initRogerVoice() {
    // TODO pass la variable dans window
    // eslint-disable-next-line
    Rogervoice('initialize', {
      organization: 'YVej5MBQK9',
      filterServices: '',
    });
  }

  function rogerVoiceClick() {
    window.RogerVoice('open');
  }
  onMounted(() => {
    if (window?.RogerVoice) {
      initRogerVoice();
    }
  });
  return {
    rogerVoiceClick,
  };
};
